import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {
  Title,
  SubTitle,
  LeftSide,
  Column,
  InputContainer,
  Text,
  CheckboxContainer,
  ListContainer,
  DropdownContainer,
  Dropdown,
  DropText,
  DropValue,
  ImageContainer,
  StyledInput,
  UploadInput,
  TextDesc,
  BannerInfo,
  AutoCompleteInput,
  TextDescAddress,
} from '../SignupPage.styles';
import Button from '../../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../../assets/icons/logoBlack.svg';
import { ReactComponent as Delete } from '../../../../assets/icons/delete.svg';
import { ReactComponent as Instagram } from '../../../../assets/icons/instagram1.svg';
import { ReactComponent as Website } from '../../../../assets/icons/website.svg';
import { ReactComponent as X } from '../../../../assets/icons/x.svg';
import { ReactComponent as Tiktok } from '../../../../assets/icons/tiktok.svg';
import Checkbox from '../../../../components/utils/Checkbox/Checkbox';
import { ReactComponent as Facebook } from '../../../../assets/icons/facebook.svg';
import PhoneNumberInput from '../../../../components/utils/PhoneInput/PhoneNumberInput';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllVendorCategories } from '../../../../store/slice/vendor/asyncThunks';
import { selectAllVendorCategoriesData } from '../../../../store/slice/vendor/slice';
import { selectOnboardingInfo, setOnboardingInfo } from '../../../../store/slice/onboarding/slice';

import { GOOGLE_API_KEY } from '../../../../utils/constants';
import ReactGoogleAutocomplete from 'react-google-autocomplete';

const Step1Page = ({ onContinueClick }) => {
  const dispatch = useDispatch();
  const vendors = useSelector(selectAllVendorCategoriesData);
  const onboardingInfo = useSelector(selectOnboardingInfo);

  const [companyName, setCompanyName] = useState(onboardingInfo.name);
  const [address, setAddress] = useState(onboardingInfo.address);
  const [phoneNumber, setPhoneNumber] = useState(onboardingInfo.phoneNumber);
  const [instagram, setInstagram] = useState(onboardingInfo.instagram);
  const [website, setWebsite] = useState(onboardingInfo.websiteLink);
  const [facebook, setFacebook] = useState(onboardingInfo.facebook);
  const [x, setX] = useState(onboardingInfo.twitter);
  const [tiktok, setTiktok] = useState(onboardingInfo.tiktok);
  const [check, setCheck] = useState(onboardingInfo.showAddress);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(onboardingInfo.vendorCategory);
  const [selectedImage, setSelectedImage] = useState(null);
  const [vendorBanner, setVendorBanner] = useState(onboardingInfo.banner);
  const [emailToShow, setEmailToShow] = useState(onboardingInfo.emailToShow);

  const clearSelectedImage = () => {
    setSelectedImage(null);
    setVendorBanner(null);
  };
  const toggleDropdown = () => {
    if (!onboardingInfo.disableCategory) {
      setIsOpen(!isOpen);
    }
  };

  const closeDropdown = vendor => {
    setSelectedVendor(vendor);
    setIsOpen(false);
  };
  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Validation functions
  const isCompanyNameValid = companyName && companyName.trim() !== '';
  const isAddressValid = address && address.trim() !== '';
  const isPhoneNumberValid = isValidPhoneNumber(phoneNumber.formattedValue ? phoneNumber.formattedValue : '');

  const isAnyInputInvalid =
    !isCompanyNameValid ||
    !isAddressValid ||
    !isPhoneNumberValid ||
    (!selectedImage && !vendorBanner) ||
    !emailToShow ||
    !validateEmail(emailToShow);

  useEffect(() => {
    dispatch(fetchAllVendorCategories());
  }, [dispatch]);

  const onContinue = () => {
    const data = {
      tab: 2,
      name: companyName,
      vendorCategory: selectedVendor,
      address,
      showAddress: check,
      phoneNumber,
      instagram,
      websiteLink: website,
      facebook,
      tiktok,
      twitter: x,
      banner: selectedImage ? URL.createObjectURL(selectedImage.file) : vendorBanner,
      emailToShow,
    };
    dispatch(setOnboardingInfo(data));
    //setSelectedImage(null);
    onContinueClick(data);
    window.scrollTo(0, 0);
  };

  return (
    <LeftSide>
      <Logo width={110} height={58} />

      <Column>
        <SubTitle>Step 1</SubTitle>
        <Title>Company Data</Title>
      </Column>
      <InputContainer>
        <StyledInput placeholder={'Company Name'} value={companyName} onChange={e => setCompanyName(e.target.value)} />
        <DropdownContainer>
          <Dropdown onClick={toggleDropdown} $open={isOpen}>
            {selectedVendor && selectedVendor.name ? (
              <DropValue>{selectedVendor.name}</DropValue>
            ) : (
              <DropText>Select Vendor</DropText>
            )}
          </Dropdown>
          {isOpen && (
            <ListContainer>
              {Object.values(vendors).map(vendor => (
                <DropValue onClick={() => closeDropdown(vendor)} key={vendor.id}>
                  {vendor.name}
                </DropValue>
              ))}
            </ListContainer>
          )}
        </DropdownContainer>
        {/* <StyledInput placeholder={'Address'} value={address} onChange={e => setAddress(e.target.value)} /> */}
        <AutoCompleteInput
          apiKey={GOOGLE_API_KEY}
          options={{
            types: ['geocode', 'establishment'],
          }}
          placeholder="Address"
          onPlaceSelected={place => {
            setAddress(place.formatted_address);
          }}
          defaultValue={address}
        />
        <TextDescAddress>
          You must select an address from the drop-down menu that appears after entering your address
        </TextDescAddress>
        <CheckboxContainer onClick={() => setCheck(!check)}>
          <Checkbox checked={!check} width={18} height={18} stroke={'black'} />
          <TextDesc>
            Check this box if you would like your location to show on your profile, otherwise, it will remain hidden.
          </TextDesc>
        </CheckboxContainer>
        <PhoneNumberInput phone={phoneNumber} setPhone={setPhoneNumber} />
        <StyledInput
          // icon={true}
          // leftIcon={<Instagram opacity={instagram !== '' ? 1 : 0.5} className="icon" />}
          placeholder={'Email for clients'}
          value={emailToShow}
          onChange={e => setEmailToShow(e.target.value)}
        />
        <StyledInput
          icon={true}
          leftIcon={<Instagram opacity={instagram !== '' ? 1 : 0.5} className="icon" />}
          placeholder={'username'}
          value={instagram}
          onChange={e => setInstagram(e.target.value)}
        />
        <StyledInput
          placeholder={'username'}
          icon={true}
          leftIcon={<Facebook opacity={facebook !== '' ? 1 : 0.5} className="icon" />}
          value={facebook}
          onChange={e => setFacebook(e.target.value)}
        />
        <StyledInput
          placeholder={'username'}
          icon={true}
          leftIcon={<X opacity={x !== '' ? 1 : 0.5} className="icon" />}
          value={x}
          onChange={e => setX(e.target.value)}
        />
        <StyledInput
          placeholder={'username'}
          icon={true}
          leftIcon={<Tiktok opacity={tiktok !== '' ? 1 : 0.5} className="icon" />}
          value={tiktok}
          onChange={e => setTiktok(e.target.value)}
        />
        <StyledInput
          icon={true}
          leftIcon={<Website opacity={website !== '' ? 1 : 0.5} className="icon" />}
          placeholder={'yourwebsite.com'}
          value={website}
          onChange={e => setWebsite(e.target.value)}
        />
      </InputContainer>

      <div style={{ position: 'relative' }}>
        {(selectedImage || vendorBanner) && (
          <ImageContainer>
            <img
              src={vendorBanner ? vendorBanner : URL.createObjectURL(selectedImage.file)}
              alt="SelectedImage"
              className="banner2"
            />
            <Delete onClick={clearSelectedImage} className="icon-delete" />
          </ImageContainer>
        )}
        {!selectedImage && !vendorBanner && (
          <Button
            width
            title={'Upload Banner Photo'}
            containerStyle={{
              background: '#f1e4df',
              boxShadow: 'none',
            }}
            titleStyle={{ color: '#000', textDecoration: 'underline' }}
          />
        )}
        <UploadInput
          type="file"
          onChange={e => {
            if (e.target.files[0]) {
              setSelectedImage({
                file: e.target.files[0],
              });
            }
          }}
          accept=".jpg, .jpeg, .png"
        />
        <BannerInfo>Banner photo (390 x 280px) is used in our app. </BannerInfo>
      </div>

      <Button disabled={isAnyInputInvalid} title={'Continue'} onClick={onContinue} width />
    </LeftSide>
  );
};

export default Step1Page;
